export default __webpack_public_path__ + "static/media/arrow_animated.dd03b901.svg";